module.exports = __webpack_public_path__ + "img/train.47692ec0.png";